import { Component, Input } from '@angular/core'
import { ContextService } from '../../services'

@Component({
  standalone: false,
  selector: 'app-map-hover-popup',
  templateUrl: './map-hover-popup.component.html',
  styleUrls: ['./map-hover-popup.component.scss'],
})
export class MapHoverPopupComponent {
  @Input() data: any
  @Input() tooltip: any[] = []
  @Input() tooltipExtra: any[] = []
  @Input() primary = true
  @Input() showFrom = true
  @Input() compareMode = false

  constructor(private context: ContextService) {}

  get title() {
    return this.data.name || `#${this.data.id}`
  }

  get keyIndicatorLabel() {
    return this.context.keyIndicator.label.toLowerCase()
  }

  get showSeparator() {
    return this.tooltip && this.tooltip.every((t) => this.data[t.value])
  }

  getDiff() {
    const { ntrips, ntrips_other } = this.data
    if (!ntrips && ntrips_other) {
      return '-100'
    }
    if (ntrips && !ntrips_other) {
      return '+100'
    }
    const percent = ((ntrips - ntrips_other) / ntrips_other) * 100
    const sign = percent >= 0 ? '+' : '−'
    return `${sign}${Math.abs(percent).toFixed(2)}`
  }

  getNvars() {
    return this.data.nvars.filter((nvar) => nvar.value !== null)
  }

  isDensityActive() {
    return this.context.isDensityActive()
  }
}
